import { Button } from "@material-ui/core";
import styled from "styled-components";

export const ButtonCarrousel = styled(Button)`
  color: #0c2d6a;
  &:disabled {
    color: #bfc2c7;
  }
`;
